<template>
  <div>
    <div class="ContainerSearchInput">
      <div class="searchInput" style="height: 100%; align-items: flex-end">
        <b-form-select
          v-if="showFilterTypes"
          id="filterType"
          class="searchFilterTypes"
          size="sm"
          value-field="value"
          text-field="text"
          v-model="filterType"
          :options="filterTypes"
        ></b-form-select>

        <b-form-select
          class="searchFilter"
          :style="
            showFilterTypes && `border-left: none; border-radius: 0 0 0 0`
          "
          size="sm"
          value-field="value"
          text-field="text"
          v-model="type"
          :options="filterCombobox"
        ></b-form-select>

        <b-input
          size="sm"
          placeholder="Pesquisar"
          v-model="textPesquisa"
          class="inputSearch"
          @keyup.enter="readCustomers(page)"
        ></b-input>

        <b-button size="sm" @click="readCustomers(page)" class="searchBtn">
          <b-icon-search></b-icon-search>
        </b-button>
      </div>

      <div>
        <p>Contador: {{ customersSelected.length }} / 1000</p>
      </div>
    </div>
    <br />
    <button
      class="btn btn-sm btn-danger"
      style="font-size: 0.8rem"
      @click="handleSelectAllCustomersList"
    >
      Selecionar todos
    </button>
    <br />
    <div class="row">
      <div
        style="
          cursor: pointer;
          margin-left: 12px;
          padding-left: 25px;
          padding-right: 25px;
          padding-top: 5px;
          padding-bottom: 5px;
          width: 270px;
          text-align: left;
          background-color: #dcdcdc29;
          font-size: 0.8rem;
        "
        class="border rounded mt-3"
        v-for="customer in customers"
        :key="customer.id"
        @click="handleSelect(customer)"
      >
        <div
          style="
            display: flex;
            gap: 10px;
            justify-content: flex-start;
            align-items: center;
          "
        >
          <div>
            <input
              type="checkbox"
              @change="addCustomer(customer)"
              :checked="!!customersSelected.find((e) => e.id === customer.id)"
            />
          </div>
          <div>
            <p style="margin: 0px; padding: 0px; font-size: 0.8rem">
              <b>Nome:</b>
              {{
                customer.nome.length > 15
                  ? customer.nome.substring(0, 15) + "..."
                  : customer.nome
              }}
            </p>
            <p style="margin: 0px; padding: 0px; font-size: 0.8rem">
              <b>Contato:</b> {{ customer.celular }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-sm-12 setBtn"
        style="float: left; margin-top: 20px; font-size: 0.8rem"
      >
        <button @click="previousPage" :disabled="page === 1" class="itemBtn">
          <b-icon-chevron-left></b-icon-chevron-left>
        </button>
        <button class="centerItemBtn">{{ page }}</button>
        <button @click="nextPageCustomer" class="itemBtn">
          <b-icon-chevron-right></b-icon-chevron-right>
        </button>
      </div>
    </div>

    <div class="col-sm-12 mt-4" style="text-align: right">
      <button
        class="btn btn-sm"
        style="background-color: #0051a9; color: #fff; font-size: 0.8rem"
        @click="handle"
      >
        Próximo
      </button>
    </div>
  </div>
</template>

<script>
import api from "../../../services/axios";
import uniqBy from "lodash.uniqby";

export default {
  props: {
    nextPage: {
      type: Function,
    },
    body: {
      type: Object,
    },
  },
  data() {
    return {
      showFilterTypes: false,
      filterType: "includes",
      customers: [],
      customersSelected: [],
      spinGeneral: "",
      textPesquisa: "",
      type: "",
      filterCombobox: [
        { value: "nome", text: "Nome" },
        { value: "sexo", text: "Sexo" },
        { value: "cidade", text: "Cidade" },
        { value: "", text: "Todos" },
      ],
      filterTypes: [
        { value: "includes", text: "Contém" },
        { value: "start", text: "Inicia por" },
      ],
      startDate: "",
      endDate: "",
      page: 1,
    };
  },
  methods: {
    async readCustomers(page) {
      try {
        this.spinGeneral = true;
        const { data } = await api.get(
          `/customers/search/wpp?q=${this.textPesquisa}&type=${this.type}&page=${page}`
        );
        this.customers = data.filter((e) => !!e.celular);
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar os clientes",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    handleSelect(customer) {
      const customerExists = this.customersSelected.find(
        (e) =>
          e.celular?.replace(/\D/g, "") === customer.celular?.replace(/\D/g, "")
      );

      console.log(customerExists, customer, this.customersSelected);

      if (customerExists) {
        this.customersSelected = this.customersSelected.filter(
          (e) =>
            e.celular?.replace(/\D/g, "") !==
            customer.celular?.replace(/\D/g, "")
        );
      } else {
        this.customersSelected.push(customer);
      }

      console.log(customerExists, customer, this.customersSelected);
    },
    handleSelectAllCustomersList() {
      this.customersSelected = uniqBy(
        [...this.customersSelected, ...this.customers],
        "id"
      );
    },
    nextPageCustomer() {
      this.readCustomers((this.page += 1));
    },
    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.readCustomers((this.page -= 1));
      }
    },
    handle() {
      const aux = this.customersSelected.map((e) => ({
        id: e.id,
        name: e.nome,
        celular: e?.celular?.replace(/\D/g, ""),
      }));

      this.body.contacts = uniqBy([...this.body.contacts, ...aux], "celular");

      this.nextPage("newCampanha");
    },
    addCustomer(customer) {
      const count = this.customersSelected.length;

      if (count === 1000) {
        this.$toast.open({
          message: "Limite máximo de 1000 contatos atingido",
          type: "info",
        });
        return;
      }

      this.customersSelected.push({
        id: customer.id,
        name: customer.name,
        celular: customer.celular,
      });
    },
  },
  created() {
    this.readCustomers(this.page);

    this.customersSelected = this.body.contacts.map((e) => {
      return {
        id: e.id,
        nome: e.name,
        celular: e.celular.replace(/\D/g, ""),
      };
    });
  },
};
</script>

<style scoped>
.ContainerSearchInput {
  display: flex;
  align-items: center;
  height: 37px;
  width: 100%;
  justify-content: space-between;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  bottom: 0;
  right: 0;
  justify-content: flex-end;
  position: relative;
}

.textRegister span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.searchInput {
  width: 50%;
  display: flex;
}

.searchInputAll {
  width: 50%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilterTypes {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilterTypes:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .ContainerSearchInput {
    padding: 3px;
  }

  .setBtn {
    margin: 0 1rem 10px 0;
  }

  .textRegister {
    font-size: 12px;
  }
  .searchInput {
    width: 60%;
  }
  .searchFilter {
    height: 25px;
    font-size: 11px;
  }
  .form-control-sm {
    padding: 0.25rem 1.2rem;
    height: 25px;
    font-size: 12px;
  }
  .searchBtn {
    right: 10px;
    height: 25px;
    display: flex;
    align-items: center;
  }
  .searchAll {
    font-size: 11px;
    padding: 2px 10px;
  }
}

@media screen and (max-width: 700px) {
  .ContainerSearchInput {
    display: flex;
    align-items: center;
    height: 70px;
    gap: 5px;
    width: 100%;
    justify-content: center;
    padding: 0;
    flex-direction: column;
  }

  .searchInput {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 3px 0 0;
  }

  .searchInputAll {
    width: 150px !important;
  }

  .rowCLient {
    gap: 5px;
    padding: 2px 5px;
    font-size: 10px;
    border-left: 5px solid rgb(64, 59, 116) !important;
  }

  .celTableInfos {
    display: none;
  }

  .searchAll {
    font-size: 10px;
    padding: 5px 10px;
  }

  .form-control-sm {
    padding: 0.25rem 0.5rem !important;
    font-size: 10px;
  }

  .searchFilter {
    width: 100px;
    font-size: 10px;
  }
}
</style>